var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.payload_num<_vm.max_num)?_c('div',{staticClass:"view-more"},[_c('span',{on:{"click":function($event){_vm.click_method && _vm.click_method()}}},[_vm._v(_vm._s(_vm.$t('filter.view_more')))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }